import React from 'react';
import type { RegistrationType } from '../../../../../../services/RegistrationService/types/registrationTypes';

/**
 * Format a full name from parts (Last, First Middle)
 */
export const formatName = (firstName?: string, middleName?: string, lastName?: string): string => {
  const parts = [lastName, firstName, middleName].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : 'Unknown';
};

/**
 * Format a date of birth string to MM/DD/YYYY
 */
export const formatDateOfBirth = (dateOfBirth?: string): string => {
  if (!dateOfBirth) return 'N/A';

  try {
    // Extract just the date part (YYYY-MM-DD) from any datetime string
    const datePart = dateOfBirth.split('T')[0].split(' ')[0];

    // Parse the date parts manually to avoid timezone issues
    const [year, month, day] = datePart.split('-');

    // Return in MM/DD/YYYY format
    return `${month}/${day}/${year}`;
  } catch {
    return 'N/A';
  }
};

interface DateOfBirthDisplayProps {
  registration: RegistrationType | undefined;
}

/**
 * Template component for date of birth
 */
export const DateOfBirthTemplate: React.FC<DateOfBirthDisplayProps> = ({ registration }) => {
  const rawDate = registration?.demographics?.dateOfBirth;
  return <span>{formatDateOfBirth(rawDate)}</span>;
};

export default DateOfBirthTemplate;
